import { useState } from 'react';
import AdminPage from '../../components/admin/AdminPage';
import { Col, Row } from 'reactstrap';
import useAdminSales from './hooks/useAdminSales';
import useAdminRent from './hooks/useAdminRent';
import { useParams } from 'react-router-dom';
import { PropertySalesPrices } from './components/Sales/PropertySalesPrices';
import SalesFinancialCard from './components/Sales/SalesFinancialCard';
import PropertySalesInfo from './components/Sales/PropertySalesInfo';
import usePropertySalesInfo from './hooks/usePropertySalesInfo';
import PropertyEstimateCard from './components/Estimate/PropertyEstimateCard';

const AdminPropertySales = () => {
  const { id: propertyId = '' } = useParams();
  const pageName = 'Administrar información de venta';
  const pageParentName = 'Propiedades';
  const [errorAlert, setErrorAlert] = useState<string>('');
  const globalAlertOptions = {
    success: false,
    warning: true,
    onConfirm: () => setErrorAlert(''),
    title: 'Error',
    text: errorAlert || '',
  };

  const { propertyPricesSaleStatus } = useAdminSales({ propertyId });
  // la moneda de la propiedad define el símbolo de los precios
  const { formUpdateData } = useAdminRent({ propertyId });

  // Una sola instancia del formulario de info de venta: la comparten "Configurar venta"
  // (disponibilidad y valores financieros) e "Información de propiedad en venta" (legales).
  const salesInfo = usePropertySalesInfo({
    propertyId,
    setErrorAlert,
    baseSalePrice: propertyPricesSaleStatus?.sale_price || 0,
    initialAvailableAt: formUpdateData?.available_at,
  });

  return (
    <AdminPage
      name={pageName}
      parentName={pageParentName}
      globalAlertOptions={globalAlertOptions}
    >
      <Row>
        <Col xs="12">
          <Row>
            {/* form prices and state for sales */}
            <Col md="12">
              {propertyPricesSaleStatus && (
                <PropertySalesPrices
                  property_id={propertyId}
                  currency={formUpdateData?.currency}
                  salesInfo={salesInfo}
                  property_sale_min_price_value={
                    propertyPricesSaleStatus.sale_min_price || 0
                  }
                  property_sale_price_value={
                    propertyPricesSaleStatus.sale_price || 0
                  }
                  property_sale_state={
                    propertyPricesSaleStatus.sale_state || ''
                  }
                />
              )}
            </Col>
          </Row>
          <SalesFinancialCard
            currency={formUpdateData?.currency}
            salesInfo={salesInfo}
          />
          <PropertyEstimateCard propertyId={propertyId} market="sale" />
        </Col>
      </Row>
      <PropertySalesInfo salesInfo={salesInfo} />
      {/* Upload files */}
    </AdminPage>
  );
};

export default AdminPropertySales;
